import { Plugin } from "ckeditor5/src/core";
import { Collection } from "@ckeditor/ckeditor5-utils";
import { UIModel as Model } from "@ckeditor/ckeditor5-ui";
import {
  createDropdown,
  addListToDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";

import StylesIcon from "./styles.svg";
export default class BlockStyleUI extends Plugin {
  destroy() {
    this.editor.off("change:isReadOnly");
  }

  init() {
    const editor = this.editor;
    const t = editor.t;
    const objectType = editor.config.get("object.type");

    // const locale = editor.locale;
    const blockStyleTypes = editor.config.get("blockStyles.options");
    const defaultTitle = t("Normal");

    editor.ui.componentFactory.add("blockStyles", (locale) => {
      const command = editor.commands.get("setBlockStyle");
      const dropdownView = createDropdown(locale);
      const options = new Collection();

      blockStyleTypes.forEach(({ label, validFor }) => {
        if (objectType && validFor.includes(objectType)) {
          options.add({
            type: "button",
            model: new Model({
              label,
              withText: true,
            }),
          });
        }
      });

      addListToDropdown(dropdownView, options);

      dropdownView.buttonView.set({
        icon: StylesIcon,
        isOn: false,
        withText: true,
        tooltip: t("Block Styles"),
      });

      dropdownView.buttonView.bind("label").to(command, "value", (value) => {
        const selectedType = blockStyleTypes.find(
          ({ model }) => model === value,
        );
        return selectedType ? selectedType.label : defaultTitle;
      });

      editor.on("change:isReadOnly", (_event, _propertyName, value) => {
        dropdownView.buttonView.isEnabled = !value;
      });

      // Execute command when an item from the dropdown is selected.
      dropdownView.on("execute", (e) => {
        const { label } = e.source;
        command.execute({ label });
      });

      return dropdownView;
    });
  }
}
